/**
 * v18 «Награды»: a medal drawn as SVG (the approved mockup look).
 * award = {title, subtitle?, style?: gold|silver|bronze|veteran|star, place?: number}
 */
const STYLES = {
  // [metal light, metal mid, metal dark, ribbon side, ribbon middle, emblem]
  gold: ['#fff1a8', '#e2b53c', '#a8741a', '#B72A2A', '#f2f2f2', 'fish', '#7a4f0c'],
  silver: ['#ffffff', '#c3cad2', '#7f8891', '#2f5f99', '#f2f2f2', 'fish', '#4f5860'],
  bronze: ['#f6c79a', '#c8834a', '#87502a', '#2e6b3a', '#f2f2f2', 'hole', '#5e3415'],
  veteran: ['#e6f7ff', '#7cc3ea', '#2f6fa8', '#1d3550', '#7cc3ea', 'snowflake', '#ffffff'],
  star: ['#fff1a8', '#e2b53c', '#a8741a', '#5a3d8c', '#e2b53c', 'star', '#a8741a']
};
let seq = 0;
function emblem(kind, color, mid) {
  switch (kind) {
    case 'fish':
      return m("g", {
        transform: "translate(0 14)"
      }, m("g", {
        fill: color
      }, m("path", {
        d: "M-13 0c5-7 14-8 20-3l6-5v16l-6-5c-6 5-15 4-20-3z"
      }), m("circle", {
        cx: "-7",
        cy: "-1.5",
        r: "1.6",
        fill: mid
      })));
    case 'hole':
      return m("g", {
        transform: "translate(0 14)"
      }, m("ellipse", {
        cx: "0",
        cy: "3",
        rx: "13",
        ry: "6",
        fill: color,
        opacity: ".9"
      }), m("ellipse", {
        cx: "0",
        cy: "3",
        rx: "8",
        ry: "3.4",
        fill: "#1d3550"
      }), m("path", {
        d: "M0 -14v14",
        stroke: color,
        "stroke-width": "1.6"
      }), m("path", {
        d: "M0 0c-2 2 -2 5 1 5",
        stroke: color,
        "stroke-width": "1.6",
        fill: "none"
      }));
    case 'snowflake':
      return m("g", {
        transform: "translate(0 18)"
      }, m("g", {
        stroke: color,
        "stroke-width": "2.4",
        "stroke-linecap": "round",
        fill: "none"
      }, [0, 60, 120].map(r => m("g", {
        transform: 'rotate(' + r + ')'
      }, m("path", {
        d: "M0 -13V13M0 -9l-4 -4M0 -9l4 -4M0 9l-4 4M0 9l4 4"
      })))));
    default:
      return m("g", {
        transform: "translate(0 18)"
      }, m("path", {
        fill: color,
        d: "M0-13l3.8 7.8 8.6 1.2-6.2 6 1.5 8.5L0 6.5-7.7 10.5l1.5-8.5-6.2-6 8.6-1.2z"
      }));
  }
}
export function medalSvg(style, place) {
  const [light, mid, dark, side, middle, kind, color] = STYLES[style] || STYLES.gold;
  const id = 'ppk2m' + ++seq;
  const g = id + 'g';
  const r = id + 'r';
  return m("svg", {
    width: "96",
    height: "125",
    viewBox: "-40 -52 80 104",
    "aria-hidden": "true"
  }, m("defs", null, m("linearGradient", {
    id: g,
    x1: "0",
    y1: "0",
    x2: "1",
    y2: "1"
  }, m("stop", {
    offset: "0",
    "stop-color": light
  }), m("stop", {
    offset: ".5",
    "stop-color": mid
  }), m("stop", {
    offset: "1",
    "stop-color": dark
  })), m("linearGradient", {
    id: r,
    x1: "0",
    x2: "1"
  }, m("stop", {
    offset: "0",
    "stop-color": side
  }), m("stop", {
    offset: ".33",
    "stop-color": side
  }), m("stop", {
    offset: ".33",
    "stop-color": middle
  }), m("stop", {
    offset: ".67",
    "stop-color": middle
  }), m("stop", {
    offset: ".67",
    "stop-color": side
  }))), m("path", {
    d: "M-17 -52h34l-6 34h-22z",
    fill: 'url(#' + r + ')',
    stroke: "rgba(0,0,0,.18)"
  }), m("rect", {
    x: "-9",
    y: "-22",
    width: "18",
    height: "6",
    rx: "2",
    fill: 'url(#' + g + ')',
    stroke: dark
  }), m("circle", {
    cx: "0",
    cy: "18",
    r: "30",
    fill: 'url(#' + g + ')',
    stroke: dark,
    "stroke-width": "1.5"
  }), m("circle", {
    cx: "0",
    cy: "18",
    r: "23",
    fill: "none",
    stroke: light,
    "stroke-width": "1.5",
    opacity: ".9"
  }), m("circle", {
    cx: "0",
    cy: "18",
    r: "23",
    fill: "none",
    stroke: dark,
    "stroke-width": ".8",
    "stroke-dasharray": "1.5 2.5",
    opacity: ".7"
  }), emblem(kind, color, mid), place ? m("text", {
    x: "0",
    y: "34",
    "font-family": "Arial",
    "font-weight": "700",
    "font-size": "11",
    fill: color,
    "text-anchor": "middle"
  }, String(place)) : null);
}
export function medal(award) {
  return m("div", {
    className: "Ppk2PubMedal"
  }, medalSvg(award.style, award.place), m("b", null, award.title), award.subtitle ? m("small", null, award.subtitle) : null);
}
flarum.reg.add('ppk2-profile', 'forum/components/Medal', { medalSvg: medalSvg,medal: medal, });